import { useMemo } from 'react';
import { useWeightByNameQuery } from 'hooks/api/weights';

export const useRTPWeights = () => {
  const {
    data: { value: RTPMedium } = { value: 0 },
    isFetching: isRTPMediumFetching,
  } = useWeightByNameQuery({
    name: 'RTPMedium',
  });
  const {
    data: { value: RTPHigh } = { value: 0 },
    isFetching: isRTPHighFetching,
  } = useWeightByNameQuery({
    name: 'RTPHigh',
  });

  const resolvedMedium = RTPMedium ?? 90;
  const resolvedHigh = RTPHigh ?? 95;

  return useMemo(
    () => ({
      isBad: (value: number) => value < resolvedMedium,
      isGood: (value: number) =>
        value >= resolvedMedium && value < resolvedHigh,
      RTPHigh: resolvedHigh,
      RTPMedium: resolvedMedium,
      isFetching: isRTPHighFetching || isRTPMediumFetching,
    }),
    [resolvedMedium, resolvedHigh, isRTPHighFetching, isRTPMediumFetching]
  );
};
